// Issue collection helpers. Severity: blocker (stops the run), warning, info.

function makeIssue(severity, code, message, extra = {}) {
  return { severity, code, message, ...extra };
}

export const blocker = (code, message, extra) => makeIssue("blocker", code, message, extra);
export const warning = (code, message, extra) => makeIssue("warning", code, message, extra);
export const info = (code, message, extra) => makeIssue("info", code, message, extra);

export function counts(issues) {
  return {
    blockers: issues.filter((i) => i.severity === "blocker").length,
    warnings: issues.filter((i) => i.severity === "warning").length,
    infos: issues.filter((i) => i.severity === "info").length,
  };
}


